import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { DiversionsCoreActions, DiversionsCoreSelectors, fromDiversionsCore } from '@ruby/modules/diversions/store/diversions-core.index';
import { EDiversionsPaths, EDiversionsSubmitDetailsType } from '@ruby/shared/enums/diversions.enum';
import {
  IDiversionsDestTurnoverForm,
  IDiversionsOrigTurnoverForm,
  IDiversionsPrivateCarForm,
  IDiversionsRequestForm,
  IDiversionsRequestSummary,
  IDiversionsReshipForm
} from '@ruby/shared/models/diversions/diversions.interface';

@Component({
  selector: 'ng-diversions-submit-details-container',
  templateUrl: './diversions-submit-details.container.html',
  styleUrls: ['./diversions-submit-details.container.scss']
})
export class DiversionsSubmitDetailsContainer {
  store$: Observable<{
    reshipCars: Array<string>;
    requestForm?: IDiversionsRequestForm;
    privateCarForm?: IDiversionsPrivateCarForm;
    originTurnoverForm?: IDiversionsOrigTurnoverForm;
    destTurnoverForm?: IDiversionsDestTurnoverForm;
    reshipForm?: IDiversionsReshipForm;
    sumDetailsSummary?: IDiversionsRequestSummary;
    sumDetailsForm?: IDiversionsRequestForm;
    sumDetailsPrivateCarForm?: IDiversionsPrivateCarForm;
    sumDestTurnoverForm?: IDiversionsDestTurnoverForm;
    sumOriginTurnoverForm?: IDiversionsOrigTurnoverForm;
    sumDetailsReshipForm?: IDiversionsReshipForm;
    type: EDiversionsSubmitDetailsType;
  }>;

  constructor(private store: Store<fromDiversionsCore.State>, private router: Router) {
    this.store$ = this.store.select(DiversionsCoreSelectors.selectDiversionsSummaryState).pipe(tap((st: {
      reshipCars: Array<string>;
      requestForm?: IDiversionsRequestForm;
      privateCarForm?: IDiversionsPrivateCarForm;
      originTurnoverForm?: IDiversionsOrigTurnoverForm;
      destTurnoverForm?: IDiversionsDestTurnoverForm;
      reshipForm?: IDiversionsReshipForm;
      sumDetailsSummary?: IDiversionsRequestSummary;
      sumDetailsForm?: IDiversionsRequestForm;
      sumDetailsPrivateCarForm?: IDiversionsPrivateCarForm;
      sumDestTurnoverForm?: IDiversionsDestTurnoverForm;
      sumOriginTurnoverForm?: IDiversionsOrigTurnoverForm;
      sumDetailsReshipForm?: IDiversionsReshipForm;
      type: EDiversionsSubmitDetailsType;
    }) => {
      if (st.type === EDiversionsSubmitDetailsType.EDIT) {
        if (st.requestForm) {
          this.router.navigate([EDiversionsPaths.REQUEST]);
        } else if (st.privateCarForm) {
          this.router.navigate([EDiversionsPaths.EMPTY_DISP]);
        } else if (st.destTurnoverForm) {
          this.router.navigate([EDiversionsPaths.DEST_TURNOVER]);
        } else if (st.originTurnoverForm) {
          this.router.navigate([EDiversionsPaths.ORIGIN_TURNOVER]);
        } else if (st.reshipForm) {
          this.router.navigate([EDiversionsPaths.RESHIP]);
        }
      }
    }));
  }

  /**
   * Dispatch Update Request Form
   *
   * @summary Dispatch update form action
   * @params $form: IDiversionsRequestForm
   * @returns void
   */
  dispatchUpdateRequestForm($form: IDiversionsRequestForm): void {
    this.store.dispatch(DiversionsCoreActions.updateForm({ data: { requestForm: $form } }));
  }

  /**
   * Dispatch Update Private Car Form
   *
   * @summary Dispatch update form action
   * @params $form: IDiversionsPrivateCarForm
   * @returns void
   */
  dispatchUpdatePrivateCarForm($form: IDiversionsPrivateCarForm): void {
    this.store.dispatch(DiversionsCoreActions.updateForm({ data: { privateCarForm: $form } }));
  }

  /**
   * Dispatch Update Origin Turnover Form
   *
   * @summary Dispatch update form action
   * @params $form: IDiversionsOrigTurnoverForm
   * @returns void
   */
  dispatchUpdateOriginTurnoverForm($form: IDiversionsOrigTurnoverForm): void {
    this.store.dispatch(DiversionsCoreActions.updateForm({ data: { originTurnoverForm: $form } }));
  }

  /**
   * Dispatch Update Destination Turnover Form
   *
   * @summary Dispatch update destination turnover form action
   * @params $form: IDiversionsDestTurnoverForm
   * @returns void
   */
  dispatchUpdateDestTurnoverForm($form: IDiversionsDestTurnoverForm): void {
    this.store.dispatch(DiversionsCoreActions.updateForm({ data: { destTurnoverForm: $form } }));
  }

  /**
   * Dispatch Update Reship Form
   *
   * @summary Dispatch update reship form action
   * @params $form: IDiversionsReshipForm
   * @returns void
   */
  dispatchUpdateReshipForm($form: IDiversionsReshipForm): void {
    this.store.dispatch(DiversionsCoreActions.updateForm({ data: { reshipForm: $form } }));
  }
}
